export type FormError = { message: string }

/*
  Get the first error message from an array of errors.
  This helper function is made to prevent dealing with the any type of errors (zod + tanstack form).
  @param errors - The array of errors.
  @returns The first error message.
*/
export function getFirstErrorMessage(errors: unknown): string | undefined {
  if (!Array.isArray(errors) || errors.length === 0) return undefined
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const first = errors[0]
  if (typeof first === "string") return first
  if (typeof first === "object" && first !== null && "message" in first) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const m = first.message
    if (typeof m === "string") return m
  }
  return undefined
}
